
export default function getBodyValue(article) {
  const { subType } = article;

  if (subType && subType === 'externalLink') {
    const { description, url } = article;
    // Store the body data in format getSections expects.
    const bodyArray = [];
    // Description as first paragraph.
    bodyArray.push({
      type: 'markup',
      element: 'p',
      html: description.primary || description.social,
    });
    // The external link.
    bodyArray.push({
      type: subType,
      url: url.primary,
    });

    return bodyArray;
  }

  // Default
  return article.body || [];
}
